import { InjectionToken } from '../../injection';

export interface IConfigurationService {
  /** The client id. */
  clientId: string;
  /** The client version. */
  clientVersion: string;
  /** The client id for client credentials login. */
  clientCredentialsClientId?: string;
  /** The client version for client credentials login. */
  clientCredentialsClientVersion?: string;
  /** The base url. */
  baseUrl: string;
  /** The api version. */
  apiVersion: string;
}

export const CONFIGURATION_SERVICE: InjectionToken<IConfigurationService>
  = new InjectionToken<IConfigurationService>('CONFIGURATION_SERVICE');

/**
 * @deprecated use CONFIGURATION_SERVICE.
 */
export const IConfigurationService = CONFIGURATION_SERVICE;
